var _effectorFileName = "/src/page-content/home/components/main/main.tsx";
import { useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { GradientBg } from '@/shared/components/animation/gradient-background';
import { Article } from '@/shared/components/article';
import DownloadIcon from '@/shared/components/icons/download-icon';
import { TextGradient } from '@/shared/components/text-gradient';
import { Button } from '@/shared/components/ui/button';
import { cn } from '@/shared/lib/cn';
export const Main = () => {
  const [imageLoaded, setImageLoaded] = useState(false);
  return <Article tag="main">
      <div className="grid grid-cols-1 items-center gap-x-4 sm:grid-cols-[1fr_minmax(200px,_40%)] sm:gap-x-10">
        <div className="mx-auto sm:mx-0">
          <div className="mb-10 sm:mb-5 sm:max-w-[620px]">
            <TextGradient text="B2B English training programs" tag="h1" className="mb-3 !text-wrap text-center text-4xl sm:mb-4 sm:max-w-lg sm:text-left lg:text-5xl" />

            <p className="mx-auto text-center text-sm xss:max-w-md sm:mx-0 sm:max-w-xl sm:text-left sm:text-base">
              Do&nbsp;your employees work with international clients, negotiating or&nbsp;preparing for new projects
              abroad?
              <br />
              <br />
              Confident proficiency in&nbsp;English is&nbsp;the key to&nbsp;success in&nbsp;the global business
              environment. We&nbsp;offer a&nbsp;tailored-made language training program specifically for your Business
              and employees to&nbsp;communicate effectively with international clients without barriers!
            </p>
          </div>

          <div className="flex flex-col items-center gap-4 sm:items-start md:gap-6 lg:flex-row lg:items-center">
            <Link href={process.env.NEXT_PUBLIC_CALENDLY_URL} rel="noopener noreferrer" target="_blank" aria-label="Company Calendly">
              <Button type="button" variant="cta" aria-label="Book a call with CEO">
                <span>Book a call with our CEO</span>
              </Button>
            </Link>

            <Link href="/files/enlerno-business-proposal.pdf" rel="noopener noreferrer" target="_blank" download="Enlerno - business proposal" aria-label="download business proposal">
              <Button className="space-x-2" type="button" variant="default" aria-label="Download business proposal">
                <span>Business proposal</span>

                <DownloadIcon className="h-5 w-5 text-brand-accent-normal dark:text-brand-accent-light" />
              </Button>
            </Link>
          </div>
        </div>

        <div className="relative hidden items-center justify-end overflow-visible sm:flex 2xl:justify-center">
          <div className="min-h-[500px] max-w-full">
            <Image src="/images/main.webp" alt="Lesson example" fill className={cn('select-none object-contain transition-opacity duration-500', imageLoaded ? 'opacity-100' : 'opacity-0')} loading="lazy" sizes="100vw" draggable={false} onLoad={() => setImageLoaded(true)} />
          </div>

          <GradientBg className="sm:var(--radial-size,100px) hidden sm:block" type="circle" origin="center" size={250} />
        </div>
      </div>
    </Article>;
};